import { render } from "./StakeDealList.vue?vue&type=template&id=456a2ec5&scoped=true&ts=true"
import script from "./StakeDealList.vue?vue&type=script&lang=ts"
export * from "./StakeDealList.vue?vue&type=script&lang=ts"

import "./StakeDealList.vue?vue&type=style&index=0&id=456a2ec5&scoped=true&lang=css"

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-456a2ec5"]])

export default __exports__